"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _modal = _interopRequireDefault(require("./modal.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Add div to the body where we will render the confirm modal
var elementId = 'cccisd-confirm';
var wrapper = document.getElementById(elementId);
if (!wrapper) {
  wrapper = document.createElement('div');
  wrapper.setAttribute('id', elementId);
  document.body.appendChild(wrapper);
}

/** cccisd-confirm provides you with confirmation window styled using bootstrap, like the Javascript confirm() functon */
var _default = exports["default"] = function _default(options) {
  if (typeof options === 'string' || /*#__PURE__*/_react["default"].isValidElement(options)) {
    options = {
      message: options
    };
  }
  var cleanup = function cleanup() {
    _reactDom["default"].unmountComponentAtNode(wrapper);
  };
  var promise = {
    onResolve: cleanup,
    onReject: cleanup,
    then: function then(callback) {
      this.onResolve = function (confirmation) {
        cleanup();
        callback(confirmation);
      };
      return this;
    },
    fail: function fail(callback) {
      this.onReject = function () {
        cleanup();
        callback();
      };
      return this;
    }
  };
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_modal["default"], _extends({}, options, {
    promise: promise
  })), wrapper);
  return promise;
};